import { useAutopilotLimits } from './useAutopilotLimits'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { isBrandPlanIntegrationType } from 'components/TacticIntegrationList/utils'

export interface AccountLimitStatus {
  limitedAccountCount: number
  maxAccounts: number
  isAtOrAboveMaxAccounts: boolean
}

export const useAccountLimitStatus = (): AccountLimitStatus => {
  const { maxAccounts } = useAutopilotLimits()
  const { data: integrationsData } = useExternalIntegrations()

  const limitedAccountCount =
    integrationsData?.external_integrations.filter((integration) => isBrandPlanIntegrationType(integration.provider))
      .length || 0

  const isAtOrAboveMaxAccounts = limitedAccountCount >= maxAccounts

  return {
    limitedAccountCount,
    maxAccounts,
    isAtOrAboveMaxAccounts,
  }
}
